<template>
  <div :class="{ flex: show.image }">
    <div v-if="show.image" class="mr-16 md:mr-24 hidden md:block">
      <div
        class="
          w-208
          h-240
          rounded-regular
          bg-black-25
          py-12
          px-20
          flex
          justify-center
          align-middle
        "
      >
        <img :src="product.standardImage" alt="">
      </div>
    </div>
    <div class="w-full">
      <div
        v-for="(flag, index) in product.flags"
        :key="index"
        class="
          inline-block
          bg-black-25
          text-black-75 text-xs
          rounded-regular
          w-fit-content
          py-4
          px-8
          mb-12
          mr-8
          font-medium
        "
      >
        <span v-if="flag.translate">
          {{ $lang("product_page", flag.value) }}
        </span>
        <span v-else>
          {{ flag.value }}
        </span>
      </div>

      <div class="flex items-center">
        <div
          class="w-full mb-8 items-start"
          :class="{
            'flex items-center': show.image,
            'justify-between': !show.shopTheLook,
          }"
        >
          <div v-if="show.image" class="mr-16 md:hidden">
            <div
              class="
                h-88
                w-64
                rounded-regular
                bg-black-25
                p-6
                flex
                justify-center
                align-middle
              "
            >
              <img :src="product.standardImage" alt="">
            </div>
          </div>
          <div
            :class="{
              'flex ': !show.image,
              'md:w-full md:flex md:justify-between': show.image,
            }"
          >
            <component
              :is="show.shopTheLook ? 'div' : 'h1'"
              class="mb-0 pr-24 w-full"
              itemprop="name"
              :class="{
                'text-product-large': !show.shopTheLook,
                'text-sm md:text-product-large': show.shopTheLook,
              }"
            >
              {{ product.title }}
            </component>
            <div
              v-if="product.showAsOnSale && !product.isArchived"
              class=" flex-shrink-0 mb-8"
              :class="{
                'text-price-large': !show.shopTheLook,
                'text-price md:text-price-large': show.shopTheLook,
              }"
            >
              <span class="ml-auto text-warning block">
                {{ product.price }}
              </span>
              <span class="line-through text-black-50 absolute">
                {{ product.priceBeforeDiscount }}
              </span>
            </div>
            <div
              v-else-if="!product.isArchived"
              :class="{
                'text-price-large': !show.shopTheLook,
                'text-price md:text-price-large': show.shopTheLook,
              }"
            >
              <span class="ml-auto" :content="product.priceAsNumber">
                {{ product.price }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="product.showAsOnSale && (product.price != product.priceHistory[0].price)" class="text-small mb-8">
        <span>{{ latestPriceText }}</span>
      </div>
      <div
        v-if="show.reviews && yotpoReview"
        class="flex text-sm items-center mb-8 h-16 cursor-pointer"
        @click.prevent.stop="$emit('toggleProductReview')"
      >
        <ReviewStars :score="yotpoReview.product_score" :placement="'product'" />
        <span class="text-muted ml-4">{{ yotpoReview.total_reviews }}
          {{ yotpoReview.total_reviews > 1 ? $lang('product_page', 'reviews') : $lang('reviews', 'review') }} </span>
      </div>
      <div v-if="show.description && !product.isArchived" class="text-small text-muted mt-8 mb-24">
        <span
          class="inline excerpt"
          itemprop="description"
          v-html="product.excerpt"
        />
        <div
          v-if="product.excerpt.length"
          class="underline text-primary cursor-pointer"
          @click="$emit('toggleProductInformation')"
        >
          {{ $lang("product_page", "read_more") }}
        </div>
      </div>
      <div
        v-if="show.variants && product.hasVariants && !product.isArchived"
        v-show="!product.hideColorChoice"
        class="mb-12"
      >
        <div class="flex w-full mb-8">
          <div class="text-small-medium font-sans">
            {{ product.variantName }}
          </div>
        </div>
        <div class="flex flex-wrap w-full mt-4">
          <div
            v-for="variant in variants"
            :key="variant.ecomId"
            class="w-68 mb-8 pr-4 md:pr-8 flex items-center justify-center"
          >
            <nuxt-link
              :to="productRoute(variant.ecomId)"
              :class="{
                'border-4 border-blue-25 rounded-sm':
                  product.ecomId === variant.ecomId,
                'cursor-pointer': product.ecomId !== variant.ecomId,
              }"
            >
              <img
                v-if="variant.mainImage"
                class="rounded-sm border h-70 w-auto"
                :class="{
                  'border-blue-50': product.ecomId === variant.ecomId,
                  'border-border': product.ecomId !== variant.ecomId,
                }"
                :src="variant.mainImage"
                :alt="variant.title"
              >
            </nuxt-link>
          </div>
        </div>
      </div>
      <div v-if="product.items.length && !product.isArchived" v-show="!product.hideSizeChoice">
        <div class="flex w-full">
          <div class="text-small-medium font-sans">
            {{ $lang("product_page", "select_size") }}
          </div>
          <div
            v-if="product.measurementChart && !show.shopTheLook"
            class="underline text-primary ml-auto text-sm cursor-pointer"
            @click.prevent="$emit('toggleSizeGuide')"
          >
            {{ $lang("product_page", "select_size_action") }}
          </div>
        </div>
        <div class="flex flex-wrap w-full mt-4">
          <div
            v-for="item in product.items"
            :key="item.item"
            class="w-1/3 mb-8 px-4"
          >
            <TabSelector
              class="px-1"
              :text="item.name"
              :monitor-stock="allowItemMonitorStockStatus(item) && !show.shopTheLook"
              :disabled="item.stock === 'no' && !(allowItemMonitorStockStatus(item) && !show.shopTheLook)"
              :selected="selectedItem && selectedItem.item === item.item"
              fullwidth
              @click="setSelectedItem(item)"
            />
          </div>
        </div>
      </div>
      <div
        v-else-if="product.isArchived"
        class="text-small text-muted mt-8 mb-24 p-12 pl-20 rounded-lg border-warning bg-warning text-white"
      >
        <span
          v-if="product.ArchivedMessage"
          class="inline"
          itemprop="archivedMessage"
          v-html="product.ArchivedMessage"
        />
        <span
          v-else
          class="inline"
          itemprop="archivedMessage"
        >{{ $lang("product_page", "product_not_available") }}</span>
      </div>
      <ButtonComponent
        v-if="!product.isArchived"
        :disabled="(product.hasVariants && !selectedItem) || isOutOfStockWithoutMonitoring"
        :loading="loadingStatus === 'LOADING'"
        is-block
        class="w-full mt-16"
        :text="
          (product.available && selectedItem && selectedItem.stock !== 'no') || !selectedItem
            ? $lang('product_page', 'add_to_cart_action')
            : (allowMonitorStockStatus && !show.shopTheLook ? $lang('product_page', 'out_of_stock_notice') : $lang('product_page', 'out_of_stock'))
        "
        @clicked="addToCart"
      />
      <div v-if="!isSeller && !show.shopTheLook">
        <iframe width="100%" height="128px" id="reviveBuyerWidget" @load="resizeBuyerIframe()" src="https://portal.reviveretail.se/widgets/v2/buyer/8f20c268-7f74-4126-9282-9f6e20c9141a" frameborder="0" referrerpolicy="unsafe-url" />
      </div>
    </div>
    <GiftCardClearCart
      v-if="modalOpen"
      :loading="loadingStatus === 'LOADING'"
      @close="modalOpen = false"
      @clear="addToCart"
    />
  </div>
</template>

<script setup lang="ts">
import type Product from '~/models/product';
import type { Currencies } from '~/constants/types/cart';
import { useConfigStore, type YotpoReview } from '~/store/config';
import { useCartStore } from '~/store/cart';
import ButtonComponent from '~/components/forms/ButtonComponent.vue';
import TabSelector from '~/components/generic/TabSelector.vue';
import ReviewStars from '~/components/productlist/ReviewStars.vue';
import type { EcomProductItem } from '~/constants/types/product';
import GiftCardClearCart from '~/components/cart/GiftCardClearCart.vue';
import useAlgoliaInsights from '~/composables/useAlgoliaInsights';
import useAlgoliaTracking from '~/composables/useAlgoliaTracking';

// Revive widget function
const resizeBuyerIframe = (() => {
  const iframe = document.querySelector('#reviveBuyerWidget');
  if (!iframe.src.split('?')[1]) {
    let paths = (window.location.href.split('?')[0].split('/') || []).reverse();
    let product_id = '';
    for (let path of paths) {
      if (path != '') {
        product_id = path;
        break;
      }
    }
    iframe.src = iframe.src + `?p_id=${product_id}`;
  }
});
const { sellerCookieOptions } = useCookieConfig();

const isSeller = useCookie<boolean>('isSeller', sellerCookieOptions);

const config = useConfigStore();
const cartStore = useCartStore();
const { $lang } = useNuxtApp();
const { trackAddToCart } = useAlgoliaInsights();
const { getQueryID, getObjectID } = useAlgoliaTracking();

interface Props {
  product: Product,
  design?: string;
}

const props = withDefaults(defineProps<Props>(), {
  design: 'ProductPage',
});

const emit = defineEmits<{
  (e: 'toggleProductReview'): void;
  (e: 'toggleProductInformation'): void;
  (e: 'toggleSizeGuide'): void;
  (e: 'toggleStockNotification'): void;
  (e: 'onItemChange', item: EcomProductItem): void;
}>();

const selectedItem = ref<EcomProductItem | null>(null);
const loadingStatus = ref('INIT');
const count = ref(1);
const modalOpen = ref(false);
const promptedModal = ref(false);

onMounted(()=> {
  if (props.product.items.length === 1) {
    selectedItem.value = props.product.items[0];
  }
});

const latestPriceText = computed<string>(()=> {
  const history = props.product.priceHistory[0] ?? null;
  return $lang('product_page', 'latest_price')
    .replace('{{days}}', history?.periodDays)
    .replace('{{price}}', history?.price);
});

const yotpoReview = computed<YotpoReview | undefined>(()=> {
  return config.yotpoReviewByProductSku(props.product?.sku);
});

const show = computed(()=>{
  return {
    image: props.design === 'Look',
    shopTheLook: props.design === 'Look',
    variants: props.design === 'ProductPage',
    reviews: props.design === 'ProductPage',
    description: props.design === 'ProductPage',
  };
});

const variants = computed<Product[]>(()=> {
  const uniqueBy = (k, s = new Set) => o => !s.has(o[k]) && s.add(o[k]);
  return (
    (props.product &&
      props.product.variants
        .filter((p) => !p.isArchived)
        .filter((p) => p.ecomId == props.product.ecomId || p.centraVariant != props.product.centraVariant)
        .filter(uniqueBy('centraVariant'))
    ) ||
    []
  );
});

const currencyCode = computed<string>(()=> {
  const fallBack = props.product?.price.replace(
    /[^a-zA-Z]+/gi,
    ''
  ) as Currencies;

  return cartStore.cartData.currency || fallBack;
});

const allowMonitorStockStatus = computed<boolean>(()=> {
  return (
    selectedItem.value?.stock === 'no' && props.product?.allowStockMonitoring
  );
});

// True when the selected item is out of stock but the "notify me" stock
// monitoring flow isn't available for it (feature disabled on this
// product). In that case there is nothing useful a click can do, so the
// item must never be addable to the cart.
const isOutOfStockWithoutMonitoring = computed<boolean>(()=> {
  return !!selectedItem.value && selectedItem.value.stock === 'no' && !props.product?.allowStockMonitoring;
});

const productRoute = (productId: number): string => {
  const route = config.getProductRoute(productId);
  return route ? route.route : '/';
};

const allowItemMonitorStockStatus = (item: any): boolean => {
  return (
    item?.stock === 'no' && props.product?.allowStockMonitoring
  );
};

const setSelectedItem = (item: EcomProductItem) => {
  selectedItem.value = item;
  emit('onItemChange', item);
};

const addToCart = async() => {
  if (
    cartStore.cartData.isGiftCardCheckout &&
    cartStore.cartData.items.length > 0 &&
    !promptedModal.value
  ) {
    modalOpen.value = true;
    promptedModal.value = true;
    return;
  }

  modalOpen.value = false;
  promptedModal.value = false;

  // Out of stock and no stock-monitoring flow to fall back to - never add
  // it to the cart (covers e.g. the single-item auto-select in onMounted,
  // which sets selectedItem without checking its stock status).
  if (isOutOfStockWithoutMonitoring.value) {
    return;
  }

  if (allowItemMonitorStockStatus(selectedItem.value)) {
    emit('toggleStockNotification');
    return;
  }

  if (props.product && props.product.available && selectedItem.value?.stock !== 'no') {
    loadingStatus.value = 'LOADING';
    try {
      await cartStore.addToCart({
        product: props.product,
        itemId: selectedItem.value.item,
        quantity: count.value,
      });
      
      // Track add to cart with Algolia (if product was clicked from search)
      const storedObjectID = getObjectID();
      const storedQueryID = getQueryID();
      
      console.log('[BuyProduct] Add to cart tracking:', {
        hasStoredObjectID: !!storedObjectID,
        storedObjectID,
        hasStoredQueryID: !!storedQueryID,
        storedQueryID,
      });
      
      if (storedObjectID) {
        trackAddToCart({
          objectIDs: [storedObjectID],
          queryID: storedQueryID || undefined,
        });
      } else {
        console.log('[BuyProduct] No stored objectID - user did not come from search');
      }
      
      setTimeout(() => (loadingStatus.value = 'SUCCESS'), 1000);
    } catch (e) {
      setTimeout(() => (loadingStatus.value = 'ERROR'), 1000);
      //error.setError(e.response.status);
    } finally {
      setTimeout(() => (loadingStatus.value = 'INIT'), 2500);
    }
  }
};
</script>

<style scoped lang="postcss">
    #reviveBuyerWidget {
      overflow: hidden;
      display: block;
      margin: auto;
      margin-top: 15px;
      border-radius: 5px;
    }
</style>
